/** What to call someone: their display name, else their handle. */
export function personName(person: { displayName: string | null; handle: string | null }): string {
  return person.displayName ?? person.handle ?? 'Someone';
}
